var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitySettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.0417C13.75 16.0417 14.2083 16.0417 14.6667 16.9584C14.6667 16.9584 16.1225 14.6667 17.4167 14.2084",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 15.5833C20.1667 18.1146 18.1146 20.1667 15.5833 20.1667C13.0521 20.1667 11 18.1146 11 15.5833C11 13.0521 13.0521 11 15.5833 11C18.1146 11 20.1667 13.0521 20.1667 15.5833Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1854 8.65099C12.6126 8.11779 11.8444 7.79163 11.0001 7.79163C9.22816 7.79163 7.79175 9.22804 7.79175 11C7.79175 11.8443 8.11791 12.6125 8.65111 13.1853",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96492 18.733C8.55647 18.3246 8.42266 18.2019 8.1635 18.094C7.90295 17.9854 7.63181 17.9815 7.05065 17.9815C5.6684 17.9815 4.87735 17.9815 4.44794 17.552C4.01853 17.1226 4.01853 16.3316 4.01853 14.9493C4.01853 14.3713 4.01474 14.0999 3.90766 13.8405C3.80017 13.5802 3.61126 13.3854 3.20061 12.9746C2.68354 12.4575 1.83325 11.8121 1.83325 11C1.83325 10.1879 2.68352 9.54245 3.20061 9.0254C3.60935 8.61667 3.79838 8.42237 3.90617 8.1631C4.01447 7.90261 4.01853 7.63153 4.01853 7.05077C4.01853 5.66852 4.01853 4.87747 4.44794 4.44806C4.87735 4.01865 5.6684 4.01865 7.05065 4.01865C7.62742 4.01865 7.89848 4.01504 8.1576 3.90852C8.41908 3.80102 8.61373 3.61229 9.02528 3.20073C9.54233 2.68364 10.2761 1.83337 10.9999 1.83337C11.7237 1.83337 12.4574 2.68366 12.9745 3.20074C13.3859 3.61205 13.5808 3.80088 13.8417 3.90829C14.1007 4.01497 14.3721 4.01865 14.9492 4.01865C16.3314 4.01865 17.1225 4.01865 17.5519 4.44806C17.9813 4.87747 17.9813 5.66852 17.9813 7.05077C17.9813 7.63022 17.9851 7.90134 18.0929 8.16131C18.2008 8.42141 18.3233 8.54438 18.7329 8.95404",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitySettings);
export default __webpack_public_path__ + "static/media/community-settings.dd8bf5b5346abefe06dfd5e177675615.svg";
export { ForwardRef as ReactComponent };